import { useDepartmentText } from 'model/DepartmentTerminology';
import { SimpleGrid, Stack } from '@mantine/core';
import ReadonlyText from 'components/typography/ReadonlyText';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { useMemo } from 'react';
import { useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * Revision metadata - basic information about the revision.
 */
export default function RevisionMetadata() {
  const departmentText = useDepartmentText();
  const { form } = useFillOutRevisionDataProvider();
  const { isTablet } = useResponsiveDesign();

  const devices = useMemo(
    () =>
      Object.values(form.values.devices)
        .filter((device) => !device.removed)
        .map(({ deviceId, fields }) => ({ key: deviceId, value: fields._deviceName ?? '' })),
    [form.values.devices]
  );

  return (
    <Stack px={isTablet ? 20 : 40} py={24} bg="gray.0" style={{ borderRadius: '4px' }}>
      <SimpleGrid cols={2} spacing={isTablet ? 20 : 40}>
        <ReadonlyText title="Názov" value={form.values.fields._revisionName ?? ''} />
        <ReadonlyText title="Zariadenie" value={devices} />
      </SimpleGrid>
      <SimpleGrid cols={2} spacing={isTablet ? 20 : 40}>
        <ReadonlyText title="Organizácia" value={form.values.fields._organization ?? ''} />
        <ReadonlyText
          title={departmentText('Položka úrovne', 'Stredisko')}
          value={form.values.fields._department ?? ''}
        />
      </SimpleGrid>
    </Stack>
  );
}
